module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2BAMAAAB+a3fuAAAAFVBMVEVHcEzY2Njb29vY2NjY2NjY2NjY2NgtNcahAAAABnRSTlMA8jrbmjt4vU0MAAAAn0lEQVQ4y2NgGAHAWQFNgMkEzjQTQpNTTEYwE1E1MokJYWVjqEXViKoUlYdmBTIX3QZkPrrLkATQtSGLYGhDCGFqQ4hh0QYTxKYNJopVG0QYuzaIRhzaQBqVcGhjYGAVE8SlDagxTYiBDDl8ZuJxCz4/4PE7vjDDE9b44ghP3OJLE3jSEr40iCft4kvzePIKvjyGL29i5OnAZKLKgmEMAJOIHW8uHMddAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/search_cancel_mb.png
// module id = VJpb
// module chunks = 42